<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Giảng viên Trường học: {{ modelData.name }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row :gutter="10">
      <div class="model-content header_2">
        <el-col :span="16">
          <el-transfer
            v-model="classPro.userInClass"
            filterable
            :left-default-checked="[]"
            :right-default-checked="[]"
            :titles="['Giảng viên toàn hệ thống', 'Giảng viên của trường']"
            :button-texts="['', '']"
            :format="{
              noChecked: '${total}',
              hasChecked: '${checked}/${total}'
            }"
            @change="handleChange"
            :data="classPro.userOutClass">
          </el-transfer>
        </el-col>
      </div>
    </el-row>
    <div style="padding-top: 20px">
      <el-button
        :disable="!canSubmit"
        :loading="!canSubmit"
        type="warning"
        size="small"
        @click="updateModel()">Cập nhật</el-button>
        <el-button
          size="small"
          class="btn-back"
          @click="backModel">Trở về
        </el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'CategoryBlogUpdate',
  metaInfo () {
    return {
      title: 'Trường học'
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  data () {
    return {
      canSubmit: true,
      activeName: 'first',
      modelData: {
        name: '',
        parant_id: '',
        priority: '',
        city_code: '',
        district_code: '',
        ward_code: '',
        status: false
      },
      classPro: {
        userInClass: [],
        userOutClass: [],
        userOutClassID: []
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchUserInClass()
    this.fetchModel()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'schools-index', text: 'Trường học' },
        { name: 'schools-update', text: 'Cập nhật' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'schools-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('schools/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            this.fetchUserOutClass()
            break
          case 422:
            this.$router.push({name: 'home-index'})
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    updateModel () {
      this.canSubmit = false
      console.log(this.classPro.userInClass)
      let data = {
        'teacher_ids': this.classPro.userInClass
      }
      axios.post('schools/update-teacher-ids/' + this.$route.params.id, data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            // this.$router.push({name: 'schools-show', params: {id: this.$route.params.id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchUserOutClass () {
      let data = {
        'limit': -1,
        'status': 1,
        'user_type': 2
      }
      axios.get('users', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.classPro.userOutClass = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchUserInClass () {
      let data = {
        'limit': -1,
        'status': 1,
        'school_id': this.$route.params.id
      }
      axios.get('school-users', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            let temp = []
            for (let i = 0; i < response.data.length; i++) {
              temp.push(response.data[i].user_id)
            }
            this.classPro.userInClass = temp
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    handleChange (value, direction, movedKeys) {
      // console.log(value, direction, movedKeys)
    }
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>
<style type="text/css">
.el-transfer-panel {
  width: 42% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/short-links/Teacher.vue